import React from "react";
import { TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  customTextField: {
    // Label color in default
    // #108ee9, #
    width: 250,
    "& .MuiInputLabel-root": {
      color: "#6c757d",
      fontSize: 11,
      fontWeight: 600,
      letterSpacing: "0.5px",
      fontFamily: "Roboto",
    },

    // Label color when focused
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#012970",
      fontSize: 14,
      // fontFamily: "revert-layer",
    },

    // Label color with field without focused
    "& .MuiInputLabel-shrink": {
      fontSize: 14,
    },

    // Border color in default mode
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#adb5bd",
    },

    // Border color when focused
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#012970",
    },

    // Fontsize when typing in Textfield
    "& .MuiInputBase-input": {
      color: "#282829",
      fontSize: 12,
      fontWeight: "600",
      fontFamily: "'Roboto', sans-serif",
    },

    //   "& .MuiFormHelperText-root": {
    //     color: "#cb0707",
    //   },

    // It will help us to remove up & down arrow for type="number" field
      "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
        {
          display: "none",
          margin: 80,
        },

      "& label.MuiFormLabel-root.Mui-error.Mui-error.MuiFormLabel-filled.MuiInputLabel-root.MuiInputLabel-formControl.MuiInputLabel-animated.MuiInputLabel-shrink":
        {
          fontSize: 15,
        },
  },
}));

export default function MuiTextField({
  id,
  label,
  size,
  onChange,
  value,
  inputRef,
  autoComplete,
  autoFocus,
  ...others
}) {
  const classes = useStyles();
  return (
    <TextField
      className={classes.customTextField}
      variant="outlined"
      id={id}
      label={label}
      size="small"
      onChange={onChange}
      value={value}
      inputRef={inputRef}
      autoComplete={autoComplete}
      autoFocus={autoFocus}
      {...others}
    />
  );
}
